import styles from '../styles/components/MapGrave.module.scss';
import SvgGrave from "../svg/SvgGrave";

export default function MapGrave({number, top = 0, left = 0, className = '', type = 'loading'}) {
    return (
        <div
            className={`${styles.pinWrapper} absolute pointer-events-none w-[31px] ${className}`}
            style={{top, left}}
        >
            <div className={styles.pin}>
                <div className={`${styles.circle} inline-flex`}
                     style={{
                         animationDelay: number ? `${(number - 1) * 500}ms` : 'none'
                     }}
                >
                    <SvgGrave className="w-full"/>
                </div>
            </div>
        </div>
    )
}
